module.exports = __webpack_public_path__ + "img/mail.6c037b99.svg";